import {
	USER,
} from '../constants';
import firebaseAdaptor from '../firebaseAdaptor';

const db = firebaseAdaptor.db;

export function loadUser(dispatch, getState){
	const { location } = getState();
	const { userId } = location.payload;
	db.collection('profiles')
		.where('uid', '==', userId)
		.get()
		.then(function(querySnapshot){
			const profile = {
				id : querySnapshot.docs[0].id,
				...querySnapshot.docs[0].data()
			};
			dispatch({
				type : USER.PROF_LOADED,
				payload : {
					profile
				}
			});
		})
		.catch(function(error){
			dispatch({
				type : USER.PROF_FAILED_LOADING,
				payload : {
					error
				}
			});
		});
            
	db.collection('recipes')
		.where('uid', '==', userId)
		.where('published', '==', true)
		.get()
		.then(function(querySnapshot){
			const recipes = querySnapshot.docs.map(doc=>{
				return {
					id : doc.id,
					...doc.data()
				};
			});
			dispatch({
				type : USER.RECIPE_LOADED,
				payload : {
					recipes
				}
			});
		})
		.catch(function(error){
			console.error(error);
			dispatch({
				type : USER.RECIPE_FAILED_LOADING,
				payload : {
					error
				}
			});
		});
            
	dispatch({
		type:USER.FETCHING,
	});
	
}